const filters = {
  IdNanmeCE: function (id, data, lang) {
    //当地雇主
    const item = data.find((item) => {
      return item.ID === id;
    });
    return item
      ? lang === "zh"
        ? item.NameinChinese
        : item.NameinChinese
      : null;
  },

  IdCityNanmeCE: function (id, data, lang) {
    //城市
    const item = data.find((item) => {
      return item.ID === id;
    });
    return item ? (lang === "zh" ? item.CityNameCHS : item.CityNameCHS) : null;
  },

  IdEmploymentNamefunction(id, data, lang) {
    //城市
    const item = data.find((item) => {
      return item.ID === id;
    });
    return item
      ? lang === "zh"
        ? item.EmploymentName
        : item.EmploymentName
      : null;
  },
};
export default filters;
